import { render, staticRenderFns } from "./GameMode.vue?vue&type=template&id=af9307d6&scoped=true"
import script from "./GameMode.vue?vue&type=script&lang=ts"
export * from "./GameMode.vue?vue&type=script&lang=ts"
import style0 from "./GameMode.vue?vue&type=style&index=0&id=af9307d6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9307d6",
  null
  
)

export default component.exports